<template>
    <button class="button-default"
            v-bind:class="[{'btn-disabled': disabled}, {'btn-outlined': outlined}, {'btn-small': small}, {'btn-cart': btnCart},
            {'slimMode': isSlimMode()}, {'alternativeLayout': isAlternativeLayout()}, {'btn-outlined-gom': layoutGom},
            {'btn-payment-gom': paymentButtonGom}, {'btn-green': green}, {'androidMode': isAndroidMode()}, {'image-right': imageRight}]"
            @click="handleClick()">
        <img v-if="icon != null" :src="icon">
        <span :class="{'single-line': singleLine}">{{ text }}</span>
    </button>
</template>

<script>
import Util from '@/assets/libs/util'
export default {
    name: 'DefaultButton',
    props: [
        'text',
        'icon',
        'disabled',
        'outlined',
        'small',
        'btnCart',
        'onClick',
        'singleLine',
        'layoutGom',
        'paymentButtonGom',
        'green',
        'imageRight'
    ],
    methods: {
        handleClick: function () {
            this.$emit('defaultBtnClick')
        },
        isSlimMode: function () {
            return Util.isSlimMode()
        },
        isAlternativeLayout: function () {
            return Util.getLocalConfigs('useAlternativeLayout')
        },
        isAndroidMode: function () {
            return Util.isAndroidMode()
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>

    @import (reference) url("../assets/common.less");

    .button-default {
        min-width: 300px;
        box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.4);
        transition: all 0.1s ease-in-out;
        user-select: none;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        outline: none;
        -webkit-tap-highlight-color: transparent;

        &:active {
            transform: scale(0.95);
            box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
        }

        &:focus {
            outline: none;
        }
        &.image-right {
            flex-direction: row-reverse;
            justify-content: center;
            align-items: center;
            img {
                margin-left: 10px;
                filter: invert(100) brightness(100%);
                width: 3.5rem;
            }
        }
    }

    img {
        width: 4rem;
        // margin: 0 0 0 15px;
    }

    span {
        font-size: 1.8rem;
        overflow: hidden;
        margin: 0;
        padding: 0;
        text-align: center;
    }

    .single-line {
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .btn-outlined {
        border: solid 1px rgba(34, 34, 34, 0.4);
    }
    /*.btn-outlined.btn-outlined-gom {
        border: solid 1px;
    } */

    .btn-disabled {
        background: #c0c0c0;
        border: none;
        pointer-events: none;

        &:active {
            transform: none;
            box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.4);
        }
    }

    .btn-payment-gom {
        margin-left: auto;
        margin-right: auto;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        border-radius: 60px;
        width: 220px;
        min-width: unset;
        height: 220px;
        box-shadow: 3px 3px 3px rgb(88, 85, 85);
        transition: all 0.2s ease-in-out;

        &:active {
            transform: scale(0.92);
            box-shadow: 2px 2px 2px rgb(88, 85, 85);
        }
        img {
            width: 60%;
            height: auto;
            max-height: 80%;
            padding-top: 20px;
            filter: invert(100) brightness(100%);
        }
        span {
            font-weight: normal;
            font-size: 1.5ch;
            width: 100%;
            height: max-content;
            .androidMode {
                .button-default {
                    min-width: 210px;
                    height: 5rem;
                }
                img {
                    width: 3rem;
                }

                span {
                    font-size: 20px;
                }
            }
        }
    }

    @media (max-width: 698px) {
        // Gertec SK210
        .button-default {
            height: 50px;
            min-width: 125px !important;
            &.image-right {
                img {
                    margin-left: 10px;
                    width: 2rem;
                }
            }
        }

        span {
            font-size: 14px !important;
            margin: 0;
        }
        .button-default.btn-payment-gom {
            width: 120px !important;
            min-width: unset !important;
            border-radius: 35px;
            height: 110px;
            span {
                font-size: 13px !important;
            }
            img {
                width: 62% !important;
                height: auto !important;
                max-height: 70% !important;
                padding-top: 10px !important;
            }
        }
    }

    @media (min-width: 699px) and (max-width: 1025px) { //@tablet
        .button-default {
            min-width: 260px;
            span {
                font-size: 20px;
            }
        }
        .btn-payment-gom {
            width: 160px;
            min-width: unset;
            border-radius: 50px;
            height: 160px;
            span {
                font-size: 18px;
            }
        }
        img {
            width: 3rem;
        }

        span {
            font-size: 1.5rem;
        }
        &.btn-cart {
        // width: 22.5rem;
        min-width: 200px !important;
    }
    }
    @media (orientation: landscape) {
        .button-default {
            min-width: 180px;
            max-width: 400px;
            max-height: 60px;
            span {
                font-size: 20px;
            }
        }
        .button-default.alternativeLayout.btn-payment-gom {
            width: 200px;
            min-width: unset;
            max-height: unset;
            border-radius: 30px;
            height: 160px;
            span {
                font-size: 1.2rem;
            }
            img {
                width: 4rem;
            }
        }
        img {
            width: 1.8rem;
        }

        span {
            font-size: 1.5rem;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/DefaultButton.vue